function configureDob(dob) {
  const [month, day, year = null] = dob.split('/');

  return {
    month: Number(month),
    day: Number(day),
    ...year && { year: Number(year) }
  };
}

function configureFullName(fullName) {
  const [firstName, ...rest] = fullName.trim().split(' ');

  return {
    firstName,
    lastName: rest.join(' ')
  };
}

export default function configureProfileInfo(details) {
  const { dateOfBirth = null, fullName = null, primarySmsNumber = null, inviteCode = null, ...rest } = details;

  const userProfile = {
    ...rest
  };

  if ('dateOfBirth' in details) {
    const birthdayInfo = dateOfBirth ? configureDob(dateOfBirth) : null;

    Object.assign(userProfile, { birthdayInfo });
  }

  if ('fullName' in details) {
    const nameDetails = fullName ? configureFullName(fullName) : { firstName: '', lastName: '' };

    Object.assign(userProfile, { ...nameDetails });
  }

  if (primarySmsNumber) {
    Object.assign(userProfile, { primarySmsNumber: primarySmsNumber.replace(/[^0-9]/g, '') });
  }

  if (inviteCode) {
    Object.assign(userProfile, { referredByCode: inviteCode.toUpperCase() });
  }

  return userProfile;
}

